const initialState = {
   allCodes: [],
   codeOptions: [],
   codes: [],
  //  allSchoolTeams: []
};

const codeReducer = (state = initialState, action) => {
  switch (action.type) {
    // 👉 CodeOptions Reducers
    case 'FETCH_CODEOPTIONS':
      return { ...state, codeOptions: action.payload };

    case 'CREATE_CODEOPTION':
      return { ...state, codeOptions: [...state.codeOptions, action.payload] };

    case 'UPDATE_CODEOPTION':
      return { ...state, codeOptions: state.codeOptions.map(option => option._id === action.payload._id ? action.payload : option) };

    case 'DELETE_CODEOPTION':
      return { ...state, codeOptions: state.codeOptions.filter(option => option._id !== action.payload) };

    // 👉 Codes Reducers
    case 'FETCH_ALL_CODES':
      return { ...state, allCodes: action.payload };

    case 'FETCH_CODES':
      return { ...state, codes: action.payload };

    case 'CREATE_CODE': {
      // codes/ answers with the existing code (200, its _id) when the team
      // name is already there in any letter case: update that row in place
      // instead of listing the team twice.
      const codes = state.codes || [];
      const id = action.payload?._id;
      if (id && codes.some((code) => code._id === id)) {
        return { ...state, codes: codes.map((code) => (code._id === id ? { ...code, ...action.payload } : code)) };
      }
      return { ...state, codes: [...codes, action.payload] };
    }

    case 'UPDATE_CODE':
      return { ...state, codes: state.codes?.map(code => code._id === action.payload._id ? action.payload : code) };

    case 'DELETE_CODE':
      return { ...state, codes: state.codes?.filter(code => code._id !== action.payload) };

    // case 'FETCH_ALL_SCHOOL_TEAMS':
    //   return { ...state, allSchoolTeams: action.payload };

    default:
      return state;
  }
};

export default codeReducer;
